import { render } from "./ManageProject.vue?vue&type=template&id=7816592a&scoped=true"
import script from "./ManageProject.vue?vue&type=script&lang=js"
export * from "./ManageProject.vue?vue&type=script&lang=js"

import "./ManageProject.vue?vue&type=style&index=0&id=7816592a&scoped=true&lang=css"
import "./ManageProject.vue?vue&type=style&index=1&id=7816592a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7816592a"]])

export default __exports__